import { defineComponent as _defineComponent } from 'vue'
import store from '@/vue/planning/store/store'
  import DatePickerV2 from './DatePickerV2.vue'
  import Participants from './participants.vue'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'DesktopSearchBar',
  setup(__props) {

  // Store
  const handleChangeOpenParticipants = (bool: boolean) => {
    store.dispatch('setParticipantsDropdownOpen', bool)
  }

  const handleSetParticipants = (newArray: Array<unknown>) => {
    store.dispatch('setParticipants', newArray)
  }

  const handleNotEnoughAdults = () => {
    store.commit('setErrorMessageOpen', 'errorMessages_notEnoughAdults')
  }

return { __sfc: true,handleChangeOpenParticipants, handleSetParticipants, handleNotEnoughAdults, DatePickerV2, Participants }
}

})